import React from "react";
import { Checkbox } from "@mui/material";
import { checkout_form } from "../../../../../CheckoutForm/CheckoutForm.constants";
import styles from "./GSTDetailsFormGroupHeader.module.scss";

const {
    gst_details: { title },
} = checkout_form;

interface IGSTDetailsFormGroupHeaderProps {
    isChecked: boolean;
    handleCheckboxChange: (value: boolean) => void;
}

const GSTDetailsFormGroupHeader: React.FC<IGSTDetailsFormGroupHeaderProps> = ({
    isChecked,
    handleCheckboxChange,
}) => {
    return (
        <div
            className={styles.Wrapper}
            onClick={() => handleCheckboxChange(!isChecked)}
        >
            <Checkbox
                checked={isChecked}
                size="medium"
                className={styles.checkBox}
            />
            <div className={styles.TitleText}>{title}</div>
        </div>
    );
};

export default GSTDetailsFormGroupHeader;
